import { $vfm } from 'vue-final-modal'
import ContentImagesModal from '@/Modals/ContentImagesModal.vue'

export default function useSearchOrSelectImage(callback) {
  const openImageModal = () => {
    $vfm.show({
      component: ContentImagesModal,
      bind: { callback }
    })
  }

  return {
    openImageModal
  }
}
